(function () {
  // Requires a local part, an "@", a domain and a TLD of at least 2 characters
  // (e.g. "name@example.com"). The native type="email" check accepts "test@test".
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.\d][^\s@.]+$/;

  if (window.__jklNewsletterValidationInit) {
    initAllNewsletterForms();
    return;
  }

  window.__jklNewsletterValidationInit = true;


  function showFieldError(errorEl, inputEl, message) {
    if (!errorEl) {
      return;
    }

    errorEl.hidden = false;
    errorEl.textContent = message;

    if (inputEl) {
      inputEl.setAttribute('aria-invalid', 'true');
      inputEl.classList.add('newsletter-field__input--error');
    }
  }

  function clearFieldError(errorEl, inputEl) {
    if (!errorEl) {
      return;
    }

    errorEl.textContent = '';

    if (inputEl) {
      inputEl.removeAttribute('aria-invalid');
      inputEl.classList.remove('newsletter-field__input--error');
    }
  }

  function initNewsletterForm(form, root) {
    if (form.dataset.newsletterValidationBound === 'true') {
      return;
    }

    const emailInput = form.querySelector('[name="contact[email]"]');
    const checkbox = form.querySelector('input[type="checkbox"][required]');
    const submitButton = form.querySelector('[data-newsletter-submit]');
    const emailError = form.querySelector('[data-newsletter-email-error]');
    const checkboxError = form.querySelector('[data-newsletter-checkbox-error]');
    const consentContainer = form.querySelector('[data-newsletter-consent]');
    const serverEmailError = form.querySelector('[data-newsletter-server-email-error]');

    if (!emailInput || !submitButton) {
      return;
    }

    form.dataset.newsletterValidationBound = 'true';
    form.setAttribute('novalidate', 'novalidate');

    const messages = {
      emailRequired: root?.dataset.emailRequiredError || 'Please enter your email address.',
      emailInvalid: root?.dataset.emailInvalidError || 'Please enter a valid email address.',
      checkboxRequired: root?.dataset.checkboxRequiredError || 'Please confirm your consent to continue.'
    };

    function validateEmail() {
      const value = emailInput.value.trim();

      if (!value) {
        showFieldError(emailError, emailInput, messages.emailRequired);
        return false;
      }

      if (!emailInput.checkValidity() || !EMAIL_PATTERN.test(value)) {
        showFieldError(emailError, emailInput, messages.emailInvalid);
        return false;
      }

      clearFieldError(emailError, emailInput);
      return true;
    }

    function validateCheckbox() {
      if (!checkbox) {
        return true;
      }

      if (!checkbox.checked) {
        showFieldError(checkboxError, checkbox, messages.checkboxRequired);
        return false;
      }

      clearFieldError(checkboxError, checkbox);
      return true;
    }

    function revealConsentIfNeeded() {
      if (consentContainer && consentContainer.style.display === 'none') {
        consentContainer.style.display = 'block';
      }
    }

    function handleSubmitAttempt() {
      revealConsentIfNeeded();

      const emailValid = validateEmail();
      const checkboxValid = emailValid ? validateCheckbox() : false;

      if (!emailValid) {
        emailInput.focus();
        return;
      }

      if (!checkboxValid) {
        checkbox.focus();
        return;
      }

      form.submit();
    }

    submitButton.addEventListener('click', handleSubmitAttempt);

    form.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target === emailInput) {
        event.preventDefault();
        handleSubmitAttempt();
      }
    });

    emailInput.addEventListener('input', function () {
      if (emailInput.getAttribute('aria-invalid') === 'true') {
        validateEmail();
      }
    });

    emailInput.addEventListener('blur', function () {
      if (emailInput.value.trim()) {
        validateEmail();
      }
    });

    emailInput.addEventListener('focus', revealConsentIfNeeded);

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (checkbox.getAttribute('aria-invalid') === 'true') {
          validateCheckbox();
        }
      });
    }

    const serverEmailMessage = serverEmailError?.dataset.newsletterServerEmailError;

    if (serverEmailMessage) {
      showFieldError(emailError, emailInput, serverEmailMessage);
    }
  }

  function initAllNewsletterForms() {
    document.querySelectorAll('[data-newsletter-form-root]').forEach(function (root) {
      const form = root.querySelector('form');

      if (form) {
        initNewsletterForm(form, root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllNewsletterForms);
  } else {
    initAllNewsletterForms();
  }
})();
